/**
 * Route Configuration
 * Centralized route definitions for the app
 */

export interface RouteConfig {
  path: string;
  id: string;
  label: string;
  title: string;
  description: string;
  keywords: string;
  showInNav?: boolean;
}

export const ROUTES: RouteConfig[] = [
  {
    path: '/',
    id: 'svg-to-code',
    label: 'SVG to Code',
    title: 'SVG to Code Converter - Extract & Copy SVG Code Instantly',
    description: 'Free online tool to extract SVG code from files. Upload SVG images and get clean, optimized code ready to use in your projects.',
    keywords: 'svg to code, svg extractor, svg code generator, convert svg to code, svg viewer',
    showInNav: true,
  },
  {
    path: '/png-to-svg',
    id: 'png-to-svg',
    label: 'PNG to SVG',
    title: 'PNG to SVG Converter - Convert Images to Vector Graphics',
    description: 'Convert PNG, JPG, and other raster images to scalable SVG vector graphics. Free online image to SVG converter.',
    keywords: 'png to svg, image to svg, convert png to svg, raster to vector, image vectorizer',
    showInNav: true,
  },
  {
    path: '/favicon-generator',
    id: 'favicon',
    label: 'Favicon',
    title: 'Favicon Generator - Create Complete Favicon Package',
    description: 'Generate all favicon sizes from any image. Creates ICO, PNG, Apple Touch Icon, Android Chrome icons, and manifest files.',
    keywords: 'favicon generator, favicon creator, ico generator, apple touch icon, android chrome icon',
    showInNav: true,
  },
  {
    path: '/image-compressor',
    id: 'compress',
    label: 'Compress',
    title: 'Image Compressor - Reduce Image File Size Online',
    description: 'Compress PNG, JPG, and WebP images without losing quality. Reduce file sizes by up to 80% for faster websites.',
    keywords: 'image compressor, compress png, compress jpg, reduce image size, image optimizer',
    showInNav: true,
  },
  {
    path: '/image-converter',
    id: 'convert',
    label: 'Convert',
    title: 'Image Format Converter - PNG, JPG, WebP, ICO Converter',
    description: 'Convert images between PNG, JPG, WebP, ICO, and BMP formats. Free online image format converter.',
    keywords: 'image converter, png to jpg, jpg to png, webp converter, image format converter',
    showInNav: true,
  },
  {
    path: '/svg-editor',
    id: 'svg-editor',
    label: 'Editor',
    title: 'SVG Editor - Edit SVG Files Online',
    description: 'Edit SVG files directly in your browser. Change colors, strokes, opacity, and transforms with a visual editor.',
    keywords: 'svg editor, edit svg online, svg color changer, svg modifier, svg tool',
    showInNav: true,
  },
  // {
  //   path: '/tutorials',
  //   id: 'tutorials',
  //   label: 'Tutorials',
  //   title: 'Web Image Optimization Tutorials & Guides - ImageLab',
  //   description: 'Complete guides and tutorials for optimizing images for the web. Learn about SVG, image formats, compression, favicons, and performance best practices.',
  //   keywords: 'image optimization tutorials, svg guide, web performance, image formats, favicon tutorial, web development guide',
  //   showInNav: true,
  // },
  {
    path: '/resources',
    id: 'resources',
    label: 'Resources',
    title: 'Web Development Resources & Articles - ImageLab',
    description: 'In-depth articles about web image optimization, Core Web Vitals, modern image formats (WebP, AVIF), SVG best practices, and performance tips.',
    keywords: 'web development resources, image optimization articles, core web vitals, webp guide, avif format, svg articles, web performance',
    showInNav: true,
  },
  {
    path: '/about',
    id: 'about',
    label: 'About',
    title: 'About ImageLab - Free Online Image Tools',
    description: 'Learn about ImageLab, a free online toolkit for image conversion, compression, and editing. Privacy-first, browser-based tools.',
    keywords: 'about imagelab, image tools, svg converter, free online tools',
    showInNav: false,
  },
  {
    path: '/faq',
    id: 'faq',
    label: 'FAQ',
    title: 'FAQ - ImageLab Help & Support',
    description: 'Find answers to frequently asked questions about ImageLab tools including SVG conversion, image compression, and favicon generation.',
    keywords: 'faq, help, support, imagelab questions, how to use',
    showInNav: false,
  },
  {
    path: '/privacy',
    id: 'privacy',
    label: 'Privacy Policy',
    title: 'Privacy Policy - ImageLab',
    description: 'Privacy policy for ImageLab. Learn how we protect your data and ensure your files stay private.',
    keywords: 'privacy policy, data protection, privacy, cookies',
    showInNav: false,
  },
];

export const NAV_ROUTES = ROUTES.filter(route => route.showInNav);

export function getRouteById(id: string): RouteConfig | undefined {
  return ROUTES.find(route => route.id === id);
}

export function getRouteByPath(path: string): RouteConfig | undefined {
  return ROUTES.find(route => route.path === path);
}
